export default __webpack_public_path__ + "static/media/Sketch.6037ad9d.svg";